import {
  Button,
  LogoutIcon,
} from "melco-ui";
import { useTranslation } from "react-i18next";

import {

  useConfirm,
} from "melco-shared-logic";
import { useUserDeviceLogout } from "../../hooks/users/useUserDevicesLogout";


type DeviceLogoutActionButtonProps = {
  userId: string;
  productCode: string;
  deviceIdToLogout: string;
  callBackFn: () => void
};

export const DeviceLogoutActionButton: React.FC<
  DeviceLogoutActionButtonProps
> = ({ userId, productCode, deviceIdToLogout, callBackFn }) => {
  const { t } = useTranslation();


  const logoutDevice = useUserDeviceLogout();

  const confirmLogoutDevice = useConfirm(
    async () => {

      await logoutDevice({
        "id": userId,
        "productCode": productCode,
        "deviceId": deviceIdToLogout
      })

      //  console.log(response)
      callBackFn();
      //console.log(response);
    },
    {
      translationPrefix: "users.tabs.devices.actions.logout",

    }
  );






  return (

    <>
      <div > {
        <Button
          icon={<LogoutIcon />}
          type="primary"

          onClick={() => {

            confirmLogoutDevice();
          }}
        >
          {t("users.tabs.devices.actions.logout.button")}
        </Button>
      }
      </div></>
  );
};
